<p-dialog
  [(visible)]="showDialog"
  (onHide)="cancelEvent.emit()"
  [header]="translationKeys.otherNameDialogComponent.html.dialogHeader | translate"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '40vw', height: '60vh' }"
>
  <avano-table
    [tableRef]="otherNameTable"
    [headerText]="translationKeys.otherNameDialogComponent.html.panelHeader | translate"
    [panelTemplates]="{ panelContentActions: panelcontentActions }"
  >
      <ng-template #panelcontentActions>
        <i class="icon-content-add" [title]="translationKeys.otherNameDialogComponent.ts.button.add | translate" (click)="addIdentifier()"></i>
        <i
          class="icon-content-trash"
          [title]="translationKeys.otherNameDialogComponent.ts.button.delete | translate"
          (click)="deleteIdentifier()"
          [attr.disabled]="deleteDisabled"
        ></i>
      </ng-template>
    <p-table
      #otherNameTable
      [columns]="columnConfig"
      [value]="rowData"
      [selectionMode]="'single'"
      [(selection)]="selectedIdentifier"
      (onRowSelect)="updateDeleteButtonStatus()"
      (onRowUnselect)="updateDeleteButtonStatus()"
      [totalRecords]="totalCount"
      [scrollable]="true"
      [dataKey]="'id'"
      [scrollHeight]="'calc(60vh - 200px)'"
      [resizableColumns]="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            *ngFor="let col of columns; let i = index"
            [avanoTableColumnHeader]="col"
            [isLastSortable]="i === columns.length - 1"
            class="scip-avano-table-no-resize-filter"
          ></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" #row>
          <td *ngFor="let col of columns">
            <div class="input-cells">
              <p-autoComplete
                *ngIf="col.field === columnKeys.pickListData"
                [suggestions]="otherNameTypesSuggestions"
                [field]="'text'"
                [(ngModel)]="rowData[col.field]"
                (completeMethod)="filterOtherNameTypesList($event)"
                [appendTo]="'body'"
                [placeholder]=""
                [dropdown]="true"
                [panelStyleClass]="'avano-scrollbars'"
                [forceSelection]="true"
                (mouseup)="row.click()"
              ></p-autoComplete>
              <input *ngIf="col.field === columnKeys.text" type="text" avanoInputText [(ngModel)]="rowData[col.field]" maxlength="255" (mouseup)="row.click()" />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </avano-table>
  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [label]="translationKeys.commonTranslationKey.btn.cancel | translate"
      [icon]="'icon-content-cancel'"
      (click)="cancelEvent.emit()"
    ></button>
    <button
      type="button"
      avanoButton
      [callToAction]="true"
      [label]="translationKeys.commonTranslationKey.btn.apply | translate"
      [icon]="'icon-content-check'"
      (click)="emitOtherNames()"
    ></button>
  </ng-template>
</p-dialog>
